export default "__VITE_ASSET__CuKXYGyh__"